module.exports = __webpack_public_path__ + "img/Fond_guirlande_lumineuse.618ff6e.jpg";